var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaypoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.54mm",
    height: "16.608mm",
    viewBox: "0 0 13.54 16.608",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath910"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.625 205.56h38.382v47.077h-38.382z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath930"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.625 205.56h38.382v47.077h-38.382z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath936"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30 209h30v12h-30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath940"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.01 209.7h28.997v10.945h-28.997z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath960"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.625 205.56h38.382v47.077h-38.382z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath966"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28 205h30v12h-30z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath970"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.227 205.56h28.997v10.946h-28.997z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-153.09 -120.16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 145.81 209.29)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath910)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#70bde5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.59 244.71h-5.2961c-0.04023 0-0.07939-4e-3 -0.11734-0.0124v0.7272c0 0.303-0.17526 0.3756-0.38953 0.1613l-2.1872-2.1871c-0.21427-0.2143-0.21427-0.5649 0-0.7792l2.1872-2.187c0.21427-0.2144 0.38953-0.1417 0.38953 0.1613v0.5792c0.03795-8e-3 0.07711-0.0123 0.11734-0.0123h5.2961c0.31558 0 0.5737 0.2581 0.5737 0.5737v2.4016c0 0.3154-0.25812 0.5737-0.5737 0.5737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.59 237.59h-5.2961c-0.04023 0-0.07939-4e-3 -0.11734-0.0124v0.7272c0 0.303-0.17526 0.3756-0.38953 0.1613l-2.1872-2.1872c-0.21427-0.2142-0.21427-0.5649 0-0.7792l2.1872-2.187c0.21427-0.2144 0.38953-0.1417 0.38953 0.1614v0.5791c0.03795-8e-3 0.07711-0.0122 0.11734-0.0122h5.2961c0.31558 0 0.5737 0.2581 0.5737 0.5737v2.4016c0 0.3154-0.25812 0.5737-0.5737 0.5737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.542 246.78-2.1872 2.1871c-0.21427 0.2143-0.38967 0.1417-0.38967-0.1613v-0.5793c-0.03781 8e-3 -0.07697 0.0124-0.1172 0.0124h-5.2961c-0.31558 0-0.57385-0.2583-0.57385-0.5739v-2.4014c0-0.3156 0.25827-0.5738 0.57385-0.5738h5.2961c0.04023 0 0.07939 4e-3 0.1172 0.0124v-0.7272c0-0.3031 0.1754-0.3756 0.38967-0.1614l2.1872 2.1872c0.21427 0.2142 0.21427 0.5649 0 0.7792"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m50.886 232.44-2.1872 2.1872c-0.21427 0.2143-0.38968 0.1417-0.38968-0.1613v-0.6078c-0.07016 0.0247-0.14426 0.0407-0.22274 0.0407h-7.6729c-0.37365 0-0.6794-0.3056-0.6794-0.6792v-2.1904c0-0.3736 0.30575-0.6794 0.6794-0.6794h7.6729c0.07848 0 0.15258 0.0162 0.22274 0.0408v-0.7556c0-0.303 0.17541-0.3756 0.38968-0.1613l2.1872 2.1871c0.21427 0.2143 0.21427 0.565 0 0.7792",
    fill: "#1e6eac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.542 239.75-2.1872 2.1872c-0.21427 0.2143-0.38967 0.1417-0.38967-0.1613v-0.578c-0.03478 7e-3 -0.07047 0.0111-0.10722 0.0111h-5.0942c-0.31013 0-0.56387-0.2538-0.56387-0.5639v-2.4214c0-0.3101 0.25374-0.5639 0.56387-0.5639h5.0942c0.03675 0 0.07244 4e-3 0.10722 0.0109v-0.7257c0-0.303 0.1754-0.3756 0.38967-0.1613l2.1872 2.1871c0.21427 0.2143 0.21427 0.565 0 0.7792",
    fill: "#a1c74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.622 213.3c0-3.0224-6.4912-5.4727-14.498-5.4727s-14.498 2.4503-14.498 5.4727c0 3.0225 6.4912 5.4728 14.498 5.4728s14.498-2.4503 14.498-5.4728",
    fill: "#175583"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath930)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath936)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.007 215.17c0-3.0225-6.4912-5.4728-14.498-5.4728s-14.498 2.4503-14.498 5.4728c0 3.0224 6.4912 5.4727 14.498 5.4727s14.498-2.4503 14.498-5.4727",
    fill: "#70bde5"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath960)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath966)",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.224 211.03c0-3.0224-6.4912-5.4727-14.498-5.4727s-14.498 2.4503-14.498 5.4727c0 3.0225 6.4912 5.4727 14.498 5.4727s14.498-2.4502 14.498-5.4727",
    fill: "#1e6eac"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m28.601 228.63c-0.04476-0.0258-0.08937-0.0517-0.13413-0.0775 0.04476 0.0258 0.08937 0.0517 0.13413 0.0775",
    fill: "#b22e4c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#175583"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.603 252.21c0-0.2347-0.6593-0.4247-1.4725-0.4247-0.81338 0-1.4727 0.19-1.4727 0.4247s0.65929 0.4248 1.4727 0.4248c0.81322 0 1.4725-0.1901 1.4725-0.4248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.603 212.52c0-0.248-0.6593-0.4491-1.4725-0.4491-0.81338 0-1.4727 0.2011-1.4727 0.4491s0.65929 0.4491 1.4727 0.4491c0.81322 0 1.4725-0.2011 1.4725-0.4491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.646 212.53h2.9509v39.705h-2.9509z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaypoint);
export default __webpack_public_path__ + "static/media/waypoint.7fa9b15ccce1540eca882de87c6b23b7.svg";
export { ForwardRef as ReactComponent };